import { forwardRef, type InputHTMLAttributes } from "react"
import { cn } from "@/shared/utils/general/cn"

/**
 * Input — matches v1 MUI OutlinedInput styling.
 *
 * v1 styles ported:
 *   - 12px border-radius (MuiOutlinedInput-notchedOutline)
 *   - Border color: text @ 9% alpha → hover: text @ 39%
 *   - Focus ring using primary color
 *   - Matching font-size/weight from v1 body2
 */
const Input = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-xl border border-foreground/9 bg-background px-3 py-2",
        "text-sm font-medium text-foreground",
        "placeholder:text-foreground/30",
        "hover:border-foreground/39",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }
